<!-- Intro Header -->
<header class="sdg-status">
  <div class="intro-body">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="col-sm-6 title">
              <h4 class="page-heading">Water-Related Sustainable Development Goals</h4>
              <h2 class="intro-text" i18n>DRR/Resilience - Data</h2>
            </div>
            <div class="col-sm-6">
              <a (click) = "resilientBtnClick()" class="col-xs-12 col-sm-6 col-md-8 btn btn-circle-sm text-center " style="margin-bottom: 15px;">
                <span i18n>Resources</span>
              </a>
              <a (click) = "quesBtnClick()" class="col-xs-12 col-sm-6 col-md-8 btn btn-circle-sm text-center " style="margin-bottom: 15px;">
                <span i18n>Questionnaire</span>
              </a>
              <a class="col-xs-12 col-sm-6 col-md-8 btn btn-circle-sm text-center" style="margin-bottom: 15px; background: #1f487c;">
                <span i18n>Data</span>
              </a>
              <a (click) = "reportBtnClick()" class="col-xs-12 col-sm-6 col-md-8 btn btn-circle-sm text-center" style="margin-bottom: 15px;">
                <span i18n>Reporting</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>

<div  *ngIf="sdgcomponent$ | async as sdgcomponent" style="width: 100% ;overflow-y: auto;">
  <section class="content-section">
    <table class="table table-striped capacity-table table-bordered data-page-table" border="0" >
      <thead>
        <tr>
          <th class="rowspan target_column" rowspan="1" style="min-width:320px;">Target</th>
          <th class="rowspan indicator_column" rowspan="1" style="min-width:280px;">Indicator</th>
          <th [ngStyle]="{'min-width.px': qt.min_col_width}" *ngFor="let qt of qtypes_new; let i = index">{{qt.display_text}}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let r of rows; let i = index">
          <th *ngIf="r.rowspan" [attr.rowspan]="r.rowspan">{{r.catname}}</th>
          <th>{{r.subcatname}}</th>
          <td *ngFor = "let rs of r.resultsarr;">{{rs.value}}</td>
        </tr>
      </tbody>
    </table>
  </section>
</div>



// WEBPACK FOOTER //
// ./src/app/sdg/resilience-data/resilience-data.component.html